<template>
    <div class="btn_l" :class="'col_down item_type'+styleCss">
        <el-button size="mini" v-if="resource.creatorId != userId && resource.myCount == 0" @click="oprate(1)"><i class="fa fa-star-o"></i><span>收藏</span></el-button>
        <el-button size="mini" v-if="resource.creatorId != userId && resource.myCount > 0" @click="oprate(1)"><i class="fa fa-star"></i><span>已收藏</span></el-button>
        <el-button size="mini" v-if="resource.typeCode!=5 && resource.typeCode!=7 && resource.typeCode!=10" @click="down"><i class="fa fa-download"></i><span>下载</span></el-button>

    </div>
</template>
<script>
export default {
    props:{
    resource:{
        type:Object,
        default:{},
    },//资源
    type:{
        type:Number,
        default:0
    },//操作类型{0.浏览，1.收藏，2.下载}
    extPro:{
        type:Number,
        dafault:0
    },//扩展字段，用于控制文字按钮的显示
    styleCss:{
        type:Number,
        dafault:0
    },

    },
    data () {
        return {
            userId:window.appframe.$store.state.userInfo.id,
            getUrl:window.systemParameter.FILE_SYSTEM_URL + "/file/get/",//单个文件请求地址
            downloadUrl:window.systemParameter.FILE_SYSTEM_URL + "/file/download/",//单个资源下载地址
        }
    },

    mounted () {
    },
    methods:{

    oprate(type){
        let  vm = this;
        http.get(InterfacePrefix['resource'] + '/common/operate/'+vm.resource.id+"/"+type).then(function (xhr) {
        if (xhr.data.code) return // 异常情况有公共处理
        if(type==0){
            vm.resource.browseCount+=1;
        }
        if(type==1){
            vm.resource.collectCount+=1;
            vm.resource.myCount=1;
        }
        if(type==2){
            vm.downImpl();
            vm.resource.downloadCount+=1;
        }
        });
    },
    //下载文件
    down(){
        let vm = this;
        vm.oprate(2);
    },

    //下载实现
    downImpl(){
        let vm= this;
        if (vm.resource.typeCode=='0' || vm.resource.typeCode=='8' ){
        //批量下载
        window.filesystemDownload([{ids:vm.resource.downLoadIds},{filename:encodeURI(vm.resource.title)}])
        }else {
        //单文件下载
        location.href=vm.downloadUrl +　vm.resource.fileId;
        }
    },
    }
}
</script>
<style lang="less" scoped>
    .btn_l{
        display: inline-block;
    }
    .list_comm_bar{
        display: inline-block;
        vertical-align: top;
        font-size: 12px;
    }
    .col_down_item{
        display: inline-block;
        vertical-align: top;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
    }
    .item_type0{
        color: #999;
        .col_item,
        .coled_item{
            span{
                display: none;
            }
            i:before{
                content: "\f006";
            }
        }
        .down_item{
            margin-left: 20px;
            i{
                display: inline-block;
                font: normal normal normal 14px/1 FontAwesome;
                font-size: inherit;
                text-rendering: auto;
                -webkit-font-smoothing: antialiased;
            }
            i:before{
                content: "\f019";
            }
        }
        .col_down_item:hover{
            color: #2babee;
        }
    }
    .item_type2{
        color: #999;
        .col_down_item{
            border:1px solid #999;
            padding:2px 5px;
            border-radius:2px;
            margin:0 6px;
            i{
                display: none;
            }
        }
        .col_down_item:hover{
            color: #2babee;
            border:1px solid #2babee;
        }
    }
</style>




// WEBPACK FOOTER //
// src/commonplugin/collection_and_down.vue